import axiosInstance from './axiosInstance';

export const getCategories = async (page = 1, limit = 10) => {
  const response = await axiosInstance.get('/categories', {
    params: {
      page,
      limit,
    },
  });
  // Assuming API response is { data: [...], total: N }
  return { data: response.data, total: response.headers['x-total-count'] || 0 };
};

export const getCategoryById = async (id) => {
  try {
    const response = await axiosInstance.get(`/categories/${id}`);
    console.log(response.data);
    
    return response.data;
  } catch (error) {
    console.error('Error fetching category:', error);
    throw error;
  }
};
